<template>
  <nav
    class="absolute top-0 w-full px-4 md:px-6 py-4 backdrop-blur-[5px] bg-black/50 border-b border-brand z-100"
  >
    <div class="flex items-center justify-between 3xl:max-w-[1280px] mx-auto">
      <!-- Logo -->
      <div class="w-16 md:w-20 relative">
        <NuxtLink :to="$localePath('/')">
        <img
          src="/images/pruta-logo-white.svg"
          alt="Pruta"
          class="w-full h-full"
        />
        </NuxtLink>
      </div>

      <!-- Desktop Menu Items -->
      <div class="hidden md:flex items-center gap-6">
        <NuxtLink
          :to="$localePath('/')"
          class="text-white font-plus-jakarta text-sm hover:text-brand transition-colors"
        >
          {{ $t("home") }}
        </NuxtLink>
        <NuxtLink
          :to="$localePath('/verified-agents')"
          class="text-white font-plus-jakarta text-sm hover:text-brand transition-colors"
        >
          {{ $t("verified_agents") }}
        </NuxtLink>
        <Button variant="outline"> Get started. It's free </Button>
        <LanguageDropdown />
      </div>

      <!-- Mobile Menu Items -->
      <div class="md:hidden flex items-center gap-4">
        <Button variant="outline" size="sm"> Get started. It's free </Button>

        <!-- Hamburger Menu Button (Mobile) -->
        <button
          @click="toggleMenu"
          class="w-6 h-6 relative flex flex-col justify-center items-center"
          aria-label="Toggle menu"
        >
          <span class="sr-only">Toggle menu</span>
          <div class="w-full flex flex-col items-center justify-center gap-1.5">
            <span
              class="w-full h-0.5 bg-white transition-all duration-300 ease-in-out"
              :class="isMenuOpen ? 'rotate-45 translate-y-2' : ''"
            ></span>
            <span
              class="w-full h-0.5 bg-white transition-all duration-300 ease-in-out"
              :class="isMenuOpen ? 'opacity-0' : 'opacity-100'"
            ></span>
            <span
              class="w-full h-0.5 bg-white transition-all duration-300 ease-in-out"
              :class="isMenuOpen ? '-rotate-45 -translate-y-2' : ''"
            ></span>
          </div>
        </button>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div
      v-if="isMenuOpen"
      class="fixed top-18 right-2 rounded-xl bg-pruta-green z-100 shadow-2xl md:hidden"
    >
      <!-- Close Button -->
      <!-- <div class="flex justify-end p-2">
        <button
          @click="closeMenu"
          class="w-8 h-8 flex items-center justify-center text-white hover:text-brand transition-colors"
          aria-label="Close menu"
        >
          <svg
            class="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div> -->

      <!-- Mobile Menu Items -->
      <div class="flex flex-col gap-6 px-4 py-4">
        <NuxtLink
          :to="$localePath('/')"
          @click="closeMenu"
          class="text-white font-plus-jakarta text-sm hover:text-brand transition-colors"
        >
          {{ $t("home") }}
        </NuxtLink>
        <NuxtLink
          :to="$localePath('/verified-agents')"
          @click="closeMenu"
          class="text-white font-plus-jakarta text-sm hover:text-brand transition-colors"
        >
          {{ $t("verified_agents") }}
        </NuxtLink>

        <!-- Language Selection (Collapsible) -->
        <div class="flex flex-col gap-4">
          <button
            @click="toggleLanguageList"
            class="flex items-center justify-between text-white font-plus-jakarta text-sm hover:text-brand transition-colors"
          >
            <span>{{ currentLanguage.label || currentLanguage.name }}</span>
            <svg
              class="w-5 h-5 flex-shrink-0 transition-transform duration-250"
              :class="{ 'rotate-180': isLanguageOpen }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          <div v-if="isLanguageOpen" class="flex flex-col gap-4 ">
            <button
              v-for="lang in locales"
              :key="lang.code"
              @click="selectLanguage(lang.code)"
              class="text-left text-white font-plus-jakarta text-sm hover:text-brand transition-colors"
              :class="{ 'text-brand font-semibold': locale === lang.code }"
            >
              {{ lang.label || lang.name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, computed } from 'vue'

const { locale, locales, setLocale } = useI18n()
const isMenuOpen = ref(false)
const isLanguageOpen = ref(false)

const currentLanguage = computed(() => {
  return locales.value.find((lang) => lang.code === locale.value) || locales.value[0]
})

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  if (!isMenuOpen.value) {
    isLanguageOpen.value = false // Close language list when menu closes
  }
}

const closeMenu = () => {
  isMenuOpen.value = false
  isLanguageOpen.value = false
}

const toggleLanguageList = () => {
  isLanguageOpen.value = !isLanguageOpen.value
}

const selectLanguage = (languageCode) => {
  setLocale(languageCode)
  closeMenu()
}
</script>
